enum CouponProvider {
  DealFuel = 'DealFuel',
}
export default CouponProvider;
